export default "__VITE_ASSET__CUKi7Fvr__"